import ExpandableList from "../common/ExpandableList";
import Place, {PlaceForm} from "./Place";
import {REST_PLACE_URL} from "../common/constants";


export const PlaceList = ExpandableList(Place, PlaceForm, REST_PLACE_URL, "place", "Seznam letišť", "Nové letiště", "Přidat letiště");

